/*
  Список докторов и выбор участвующих
*/

import './NewClient.css';
import '../css/Main.css';
import React , { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import TextBox from '../elements/TextBox.js';
import axios_sender from '../modules/axios_sender.js'

function Clients(props) {



  const [client_name, SetClientName] = useState();                      // ФИО клиента
  const [client_address, SetClientAddress] = useState();                // адрес клиента
  const [client_tel, SetClientTel] = useState();                        // телефон клиента

  const navigate = useNavigate();

  useEffect(() => {
      }, []);

  return (
            <>
            <div className="page-caption-2">ФОРМА НОВОГО ВЛАДЕЛЬЦА</div>                  
                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">ФИО</span>
                        <TextBox cnTextBox="col input-group-text"
                              caption="Имя владельца"
                              value={ client_name }
                              onChange={ (v) => SetClientName(v)}
                              />
                  </div>

                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Адрес</span>
                        <TextBox cnTextBox="col input-group-text"
                              caption="Адрес владельца"
                              value={ client_address }
                              onChange={ (v) => SetClientAddress(v)}
                              />
                  </div>

                  <div className="input-group mb-1">
                        <span className="input-group-text col-4">Телефон</span>
                        <TextBox cnTextBox="col input-group-text"
                              caption="Телефон владельца"
                              value={ client_tel }
                              onChange={ (v) => SetClientTel(v)}
                              />
                  </div>

                  

                  <div style={{marginTop: 20 + 'pt'}}>
                        <button type="button" className="btn btn-primary btn-lg" onClick={ () => AddNewClient() }>Сохранить и выбрать</button>
                  </div>

            </>
  );

  function AddNewClient()
  {
      // проверим, может такой клиент уже существует...

      axios_sender({form: 'is_client_exist', name: client_name, address: client_address, tel: client_tel}, (data) => {

          if(data > 0)
              if(window.confirm("Пользователь с такими данными (или имя или телефон или адрес) существует. Продолжить?") == false) return;

          axios_sender({form: 'add_client', name: client_name, address: client_address, tel: client_tel}, (data) => {
              if(data > 0)
              {
                  let client = { ID: data, name: client_name, address: client_address, telephone: client_tel };                  
                  navigate('/Clients', { state: { param: client } });
              }
          });

      });

  }

}

export default Clients;
